import { getVideoProjectionSnapshot, videoProjectionAdapter, } from './videoProjectionAdapter';
export { DefaultVideoDataProvider } from './DefaultVideoDataProvider';
export { createDefaultVideoRenderPaths, createVideoRenderPathResolver, } from './VideoRenderPathResolver';
export const videoProjection = {
    adapter: videoProjectionAdapter,
    getSnapshot: getVideoProjectionSnapshot,
};
export { default } from './VideoViewport';
